(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    (global = typeof globalThis !== 'undefined' ? globalThis : global || self, (global.themegoal = global.themegoal || {}, global.themegoal.components_business = global.themegoal.components_business || {}, global.themegoal.components_business.product_variants = factory()));
  })(this, (function () { 'use strict';

  class ProductImageModal {
    constructor(element) {
      this.element = element;
      this.delegateElement = new themegoal.libs.Delegate(this.element);

      this.quiviewModalElement = document.getElementById('ProductMediaZoomModal');
      if (!this.quiviewModalElement) {
        return;
      }

      if (!document.body.contains(this.quiviewModalElement)) {
        document.body.appendChild(this.quiviewModalElement);
      }

      this.quiviewModal = null;
      this.modalCarouselElement = this.quiviewModalElement ? this.quiviewModalElement.querySelector('.ProductMediaModalSlider') : null;
      this.modalCarousel = null;

      this.activeMedia = null;

      this.productGalleryElement = this.element.querySelector('.ProductGallery__Carousel');
      this.productGalleryFlickity = this.productGalleryElement ? Flickity.data(this.productGalleryElement) : null;
      this.carouselIsDragging = false;

      this._bindEventsListeners();
      this._bindCarouselDragState();
    }

    destroy() {
      this.delegateElement.off('click');

      if (this.modalCarousel) {
        this.modalCarousel.destroy();
      }
    }

    _bindEventsListeners() {
      this.delegateElement.on('click', '.MediaModalOpener', this._openMediaModal.bind(this), true);
      this.quiviewModalElement.addEventListener('hidden.tg.Modal', function (event) {
        window.pauseAllMedia();
      });
      let _this = this;
      this.quiviewModalElement.addEventListener('shown.tg.Modal', function (event) {
        window.pauseAllMedia();
        _this.activeMedia.scrollIntoView({ behavior: 'smooth', block:"start"});
        _this._ensureModalCarousel();

        if (_this.modalCarousel) {
          _this.modalCarousel.resize();
        }
      });
    }

    _bindCarouselDragState() {
      if (!this.productGalleryFlickity) {
        return;
      }

      var _this = this;

      this.productGalleryFlickity.on('dragStart', function () {
        _this.carouselIsDragging = true;
      });

      var resetDraggingState = function resetDraggingState() {
        _this.carouselIsDragging = false;
      };

      this.productGalleryFlickity.on('dragEnd', resetDraggingState);
      this.productGalleryFlickity.on('staticClick', resetDraggingState);
      this.productGalleryFlickity.on('settle', resetDraggingState);
    }

    _openMediaModal(event, target) {
      event.preventDefault();

      if (!this.quiviewModalElement) {
        return;
      }

      if (this.carouselIsDragging) {
        return;
      }

      let imageBreakpoint = themegoal.helpers.Responsive.getCurrentBreakpoint();

      this._ensureModalCarousel();

      if ( imageBreakpoint == "small" ){
        event.stopImmediatePropagation();
        this._setActiveMeida(target);
        this.quiviewModal = new themegoal.components.Modal(this.quiviewModalElement);
        this.quiviewModal.show();
      }else{
        if (target.classList.contains("MediaModalOpener--image")){
          this._setActiveMeida(target);
          this.quiviewModal = new themegoal.components.Modal(this.quiviewModalElement);
          this.quiviewModal.show();
        }
      }
    }

    _ensureModalCarousel() {
      if (!this.modalCarouselElement || this.modalCarousel) {
        return;
      }

      let _this = this;
      this.modalCarousel = new themegoal.components.Carousel(this.modalCarouselElement, {
        onSelect: function onSelect(index, selectedCell) {
          let mediaId = selectedCell.getAttribute("data-media-id");

          if (!mediaId) {
            let innerMedia = selectedCell.querySelector('[data-media-id]');
            mediaId = innerMedia ? innerMedia.getAttribute('data-media-id') : null;
          }

          if (mediaId) {
            _this._syncActiveMedia(mediaId);
          }
        }
      });
    }

    _setActiveMeida(target){
      let currentMediaId = target.getAttribute("data-media-id");

      if (this.modalCarousel) {
        this._selectCarouselMedia(currentMediaId);
      }

      this._syncActiveMedia(currentMediaId);
    }

    _selectCarouselMedia(mediaId) {
      if (!this.modalCarouselElement || !this.modalCarousel) {
        return;
      }

      let cells = this.modalCarouselElement.querySelectorAll('.Carousel__Item');
      let targetIndex = Array.prototype.findIndex.call(cells, function (cell) {
        if (cell.getAttribute('data-media-id') === mediaId) {
          return true;
        }

        let innerMedia = cell.querySelector('[data-media-id]');
        return innerMedia && innerMedia.getAttribute('data-media-id') === mediaId;
      });

      if (targetIndex >= 0) {
        this.modalCarousel.selectCell(targetIndex, true, false);
      }
    }

    _syncActiveMedia(currentMediaId) {
      let openers = this.quiviewModalElement.querySelectorAll(".Product__MediaWrapper");

      if(openers){
        openers.forEach(function (item) {
          item.classList.remove("Active");
        });

        this.activeMedia = this.quiviewModalElement.querySelector('[data-media-id="'+ currentMediaId +'"]');
        if(this.activeMedia){
          this.activeMedia.classList.add("Active");
        }
      }
    }
  }

  class ProductPickupAvailability {
    constructor(element, productTitle) {
      this.element = element;
      this.productTitle = productTitle;
    }

    updateWithVariant(variant) {
      if (!this.element) {
        return; // If the element to inject the store availability does not exist, we return immediately
      }

      // If the variant is null (for instance unavailable variant), we clear the container
      if (!variant) {
        this.element.textContent = '';
        return;
      }

      // If we have a new variant we render the section
      this._renderAvailabilitySection(variant['id']);
    }

    _renderAvailabilitySection(id) {
      let _this = this;

      this.element.innerHTML = '';

      // If there is already an element with the given modal we remove it first
      var availabilityModal = document.getElementById('PickupAvailabilityModal-' + id);
      if (availabilityModal) {
        availabilityModal.remove();
      }

      return fetch(window.routes.rootUrlWithoutSlash + '/variants/' + id + '?section_id=pickup-availability').then(function (response) {
        return response.text().then(function (content) {
          _this.element.innerHTML = content;
          _this.element.innerHTML = _this.element.firstElementChild.innerHTML;

          // The product title is not rendered so we have to render it manually
          var productTitle = _this.element.querySelector('.Drawer__Title.Product__Title');

          if (productTitle) {
            productTitle.textContent = _this.productTitle;
          }

          // In order for our modal system to work we have to append the modal to the body instead
          let availabilityModal = document.getElementById('PickupAvailabilityModal-' + id);

          if(availabilityModal){
            document.body.appendChild(availabilityModal);

            // Create the drawer
            new themegoal.components.Drawer(availabilityModal);
          }
        });
      });
    }
  }
  class ProductVariants {
    constructor(container, options) {
      let _this = this;

      this.element = container;
      this.delegateElement = new themegoal.libs.Delegate(this.element);
      this.options = options;

      let jsonData = JSON.parse(this.element.querySelector('[data-product-json]').innerHTML);

      this.productData = jsonData['product'];
      this.variantsInventories = jsonData['inventories'] || {};
      this.formattedPrices = jsonData['formatted_prices'] || {};
      this.sectionId = jsonData['section_id'];
      this.variantSelector = this.element.querySelector('#ProductSelect--' + this.sectionId);

      if(!this.productData['id']) return ;
      // We init value with the first selected variant
      this.productData['variants'].forEach(function (variant) {
        if (variant['id'] === jsonData['selected_variant_id']) {
          _this.currentVariant = variant;
          _this.option1 = variant['option1'];
          _this.option2 = variant['option2'];
          _this.option3 = variant['option3'];
        }
      });

      this.pickupAvailability = new ProductPickupAvailability(this.element.querySelector('.Product__StoreAvailabilityContainer'), this.productData['title']);
      this.pickupAvailability.updateWithVariant(this.currentVariant);

      // Der Preis, mit dem Liquid die Seite gerendert hat — der Ab-Preis, oder
      // der eines Deep-Links. previewPrice(null) findet dahin zurueck.
      let renderedPrice = this.element.querySelector('.Product__PriceList');
      this._renderedPriceHtml = renderedPrice ? renderedPrice.innerHTML : null;

      this._bindEventsListeners();
      this._initLowestPriceObserver();

    }

    destroy() {
      this.delegateElement.off('click');
    }

    _bindEventsListeners() {
      this.delegateElement.on('click', '[data-action="add-to-cart"]', this._addToCart.bind(this));
      this.delegateElement.on('click', '[data-action="decrease-quantity"]', this._decreaseQuantity.bind(this));
      this.delegateElement.on('click', '[data-action="increase-quantity"]', this._increaseQuantity.bind(this));
      this.delegateElement.on('change', '.ProductForm__QuantityNum', this._validateQuantity.bind(this));

      // Hook when a radio button change
      this.delegateElement.on('change', '.ProductForm__Option [type="radio"]', this._onOptionChanged.bind(this));
      this.delegateElement.on('keydown', '.ProductForm__Option [type="radio"]~label', this._labeEnerKeyEvent.bind(this));

      this.delegateElement.on('change', '.ProductForm__Option .Form__Select', this._onOptionChanged.bind(this));

      this.delegateElement.on('change', '.ProductForm__CustomProperty [type="radio"]', this._onChangeCustomPropertyRadio.bind(this));
      this.delegateElement.on('change', '.ProductForm__CustomProperty .Form__Select', this._onChangeCustomPropertySelect.bind(this));
      this.delegateElement.on('change', '.ProductForm__CustomProperty .Form__Input', this._onChangeCustomPropertyText.bind(this));
    }

    /**
     * Vorauswahl beim Laden: die guenstigste VERFUEGBARE Variante (Karim
     * 2026-09-10 — die Vorauswahl bleibt, der Groessen-Drawer oeffnet damit
     * bereits markiert). Ein ?variant= in der URL gewinnt immer.
     *
     * Frueher wurde dafuer das Options-Dropdown gesetzt und notfalls per
     * body-weitem MutationObserver darauf gewartet. Beides entfaellt: im
     * Size-Picker-Modus gibt es kein Dropdown mehr, und selectVariant() geht
     * denselben Weg wie eine Nutzerauswahl.
     */
    _initLowestPriceObserver() {
      // Im Size-Picker-Modus bleibt die Seite ohne Auswahl stehen, bis der
      // Kunde eine Groesse antippt (Karim 2026-09-10). Die frueher hier
      // vorgewaehlte guenstigste Variante ist damit weg.
      if (this.options['sizePicker']) {
        return;
      }

      let urlParams = new URLSearchParams(window.location.search);
      if (urlParams.has('variant')) {
        return;
      }

      if (!this.productData || !Array.isArray(this.productData['variants'])) {
        return;
      }

      let lowestPriceVariant = this.productData['variants'].reduce(function (lowest, variant) {
        if (!variant['available']) {
          return lowest;
        }
        if (!lowest) {
          return variant;
        }

        return variant['price'] < lowest['price'] ? variant : lowest;
      }, null);

      if (!lowestPriceVariant) {
        return;
      }

      if (this.currentVariant && this.currentVariant['id'] === lowestPriceVariant['id']) {
        return;
      }

      this.selectVariant(lowestPriceVariant['id']);
    }

    /**
     * Eine Variante per ID waehlen — der einzige Weg, den der Size-Picker
     * nimmt. Macht exakt das, was eine Nutzerauswahl im Dropdown ausloest:
     * Optionen setzen, variant:changed feuern, ?variant= schreiben und das
     * versteckte Select nachziehen (dort haengt das Warenkorb-Formular dran).
     */
    selectVariant(variantId) {
      let target = null;

      this.productData['variants'].forEach(function (variant) {
        if (String(variant['id']) === String(variantId)) {
          target = variant;
        }
      });

      if (!target) {
        return null;
      }

      this.option1 = target['option1'];
      this.option2 = target['option2'];
      this.option3 = target['option3'];

      let previousVariant = this.currentVariant;
      this.currentVariant = target;

      this._onVariantChanged(previousVariant, target);

      if (this.options['enableHistoryState']) {
        this._updateHistoryState(target);
      }

      this._syncVariantSelector(target);

      return target;
    }

    /**
     * Das versteckte <select name="id"> nachziehen. Traegt die Varianten-ID
     * ins Produktformular; das native change-Event ist fuer App-Bloecke da,
     * die auf select[name=id] hoeren (Omnibus, Klaviyo).
     */
    _syncVariantSelector(variant) {
      if (!this.variantSelector || !variant) {
        return;
      }

      let previouslySelected = this.variantSelector.querySelector('[selected]');
      if (previouslySelected) {
        previouslySelected.removeAttribute('selected');
      }

      let option = this.variantSelector.querySelector('[value="' + variant['id'] + '"]');
      if (option) {
        option.setAttribute('selected', 'selected');
      }

      this.variantSelector.value = String(variant['id']);
      this.variantSelector.dispatchEvent(new Event('change', { bubbles: true }));
    }

    /** Warenkorb-Zugriff ohne Klick-Event — der Drawer-Button liegt nach dem
     *  Verschieben nach <body> ausserhalb dieser Section. */
    addToCart() {
      return this._addToCart(null);
    }

    _labeEnerKeyEvent(event, target){
      if(event.keyCode == 13) {
        let inputId = target.getAttribute("for");
        let inputElement = document.getElementById(inputId);
        inputElement.click();
      }
    }

    _onVariantChanged(previousVariant, newVariant) {
      this._updateProductInfo(newVariant);

      // update the add to cart button
      this._updateAddToCartButton(newVariant, previousVariant);

      // pick availability
      this.pickupAvailability.updateWithVariant(newVariant);

      // Finally, we send an event so that other system could hook and do their own logic
      this.element.dispatchEvent(new CustomEvent('variant:changed', {
        bubbles: true,
        detail: {
          variant: newVariant,
          previousVariant: previousVariant,
          // Vom Size-Picker gesetzt: die normalisierte Lieferstufe der
          // Variante. Null, solange kein Size-Picker aktiv ist.
          sizeTier: (this.sizeTiers && newVariant) ? (this.sizeTiers.byVariantId[String(newVariant['id'])] || null) : null
        }
      }));

    }

    /** Das Markup des grossen Preises, aus rohen Zahlen. Eine Stelle fuer
     *  beide Aufrufer: die Variantenauswahl unten und die Preisvorschau des
     *  Size-Pickers. `formattedPrice` ist der in Liquid mit money() gesetzte
     *  Text, wenn es ihn gibt — sonst formatiert der Theme-Helper. */
    _priceListHtml(money) {
      let fmt = window.theme && window.theme.moneyFormat;
      let show = function (cents, ready) {
        if (ready) return ready;
        return themegoal.helpers.Currency.formatMoney(cents, fmt);
      };
      let priceHtml = show(money['price'], money['formattedPrice']);
      if (money['compareAtPrice'] && money['compareAtPrice'] > money['price']) {
        return '<span class="Price Price--sale">' + priceHtml + '</span>' +
          '<span class="Price Price--saleRegular">' +
          show(money['compareAtPrice'], money['formattedCompareAtPrice']) + '</span>';
      }
      return '<span class="Price">' + priceHtml + '</span>';
    }

    /**
     * Nur den grossen Preis setzen, ohne die Variante zu uebernehmen.
     *
     * Der Size-Picker laesst die Produktseite bis zum Warenkorb-Klick sonst
     * unberuehrt (Karim 2026-09-12: Galerie, ?variant= und Lagerinfo sollen
     * stehen bleiben). Beim Preis wollen Kunden das anders — er muss der
     * angetippten Groesse folgen (2026-09-16). Das ist genau diese Tuer: der
     * Preis folgt, alles andere nicht.
     *
     * `null` stellt den Stand wieder her, mit dem die Seite gerendert wurde
     * (Ab-Preis, oder der Preis eines Deep-Links).
     */
    previewPrice(money) {
      let destination = this.element.querySelector('.Product__PriceList');
      if (!destination) return;
      if (this._renderedPriceHtml == null) this._renderedPriceHtml = destination.innerHTML;
      destination.innerHTML = money ? this._priceListHtml(money) : this._renderedPriceHtml;
    }

    _updateProductInfo(newVariant){
      let _this = this;

      let destinationPriceList = _this.element.querySelector(".Product__PriceList");
      let destinationSKU = _this.element.querySelector(".Product__Sku");
      let destinationUnitPrice = _this.element.querySelector(".Product__UnitPrice");
      let destinationInventory = _this.element.querySelector('.ProductForm__Inventory');
      let destinationPayInstallments = _this.element.querySelector(".Product__PayInstallments");

      if (!newVariant){
        if(destinationPriceList) destinationPriceList.innerHTML = "";
        if(destinationSKU) destinationSKU.innerHTML = "";
        if(destinationUnitPrice) destinationUnitPrice.innerHTML = "";
        if(destinationInventory) destinationInventory.innerHTML = "";
        if(destinationPayInstallments) destinationPayInstallments.innerHTML = "";
        return;
      }

      // Sofortiger Preis aus den bereits vorhandenen Variantendaten. Der Fetch
      // unten ueberschreibt ihn gleich mit identischem Markup — er wird nur
      // noch fuer Shop-Pay-Raten (payment_terms) und die Bestandszeile
      // gebraucht, die Liquid rendern muss.
      if (destinationPriceList) {
        try {
          let pre = _this.formattedPrices ? _this.formattedPrices[String(newVariant['id'])] : null;
          destinationPriceList.innerHTML = _this._priceListHtml({
            price: newVariant['price'],
            compareAtPrice: newVariant['compare_at_price'],
            formattedPrice: pre && pre['price'],
            formattedCompareAtPrice: pre && pre['compare_at_price']
          });
        } catch (e) { /* Fetch unten liefert den Preis ohnehin nach */ }
      }

      fetch(window.routes.rootUrlWithoutSlash + '/variants/' + newVariant['id'] + '?section_id=product-info').then(function (response) {
        return response.text().then(function (content) {
          const html = new DOMParser().parseFromString(content, 'text/html');

          const sourcePriceList = html.querySelector(".Product__PriceList");
          if (sourcePriceList && destinationPriceList) destinationPriceList.innerHTML = sourcePriceList.innerHTML;

          if (_this.options['showSku']) {
            const sourceSKU = html.querySelector(".Product__Sku");
            if (sourceSKU && destinationSKU) {
              destinationSKU.innerHTML = sourceSKU.innerHTML;
              destinationSKU.style.display = sourceSKU.style.display;
            };
          }

          const sourceUnitPrice = html.querySelector(".Product__UnitPrice");
          if (sourceUnitPrice && destinationUnitPrice) {
            destinationUnitPrice.innerHTML = sourceUnitPrice.innerHTML;
            destinationUnitPrice.style.display = sourceUnitPrice.style.display;
          };

          if (_this.options['showInventoryQuantity']) {

            let variantInventory = newVariant ? _this.variantsInventories[newVariant['id']] : null;

            if(destinationInventory && variantInventory){
              const sourceInventory = html.querySelector(".ProductForm__Inventory");

              if (sourceInventory) {
                let inventoryQuantity = variantInventory['inventory_quantity'];

                if (inventoryQuantity <= 0) {
                  destinationInventory.innerHTML = sourceInventory.innerHTML;
                  destinationInventory.style.display = '';
                } else if (null === newVariant['inventory_management'] || (_this.options['inventoryQuantityThreshold'] > 0 && inventoryQuantity > _this.options['inventoryQuantityThreshold'])) {
                  destinationInventory.style.display = 'none';
                } else {
                  destinationInventory.innerHTML = sourceInventory.innerHTML;
                  destinationInventory.style.display = '';
                }
              } else {
                destinationInventory.style.display = 'none';
              }
            }
          }

          const sourcePayInstallments = html.querySelector(".Product__PayInstallments");
          if (sourcePayInstallments && destinationPayInstallments) destinationPayInstallments.innerHTML = sourcePayInstallments.innerHTML;

        });
      });
      // renderStockInfo lebt in stock-info-logic.js und wird von theme.liquid
      // geladen. Seit die Vorauswahl beim Aufbau der Seite ueber selectVariant
      // laeuft, kann dieser Aufruf FRUEHER kommen als jenes Skript — ungeprueft
      // warf er dann "renderStockInfo is not defined" in die Konsole und die
      // Lagerzeile blieb leer (gefunden 2026-09-10).
      setTimeout(() => {
        if (typeof window.renderStockInfo === 'function') {
          window.renderStockInfo(newVariant);
        }
      }, 300);
    }

    _updateAddToCartButton(newVariant) {
      // Size-Picker-Modus: der Hauptbutton der Produktseite ist der
      // Drawer-Trigger („Groesse waehlen“, wie in der Referenz) und darf nicht
      // in einen Add-to-Cart umgebaut werden. Gekauft wird im Drawer-Footer.
      // Der Payment-Button wird trotzdem gesteuert.
      if (this.options['sizePicker']) {
        let paymentButton = this.element.querySelector('.shopify-payment-button');
        if (this.options['showPaymentButton'] && paymentButton) {
          paymentButton.style.display = (!newVariant || !newVariant['available']) ? 'none' : 'block';
        }
        return;
      }

      let addToCartButton = this.element.querySelector('.ProductForm__AddToCart'),
        shopifyPaymentButton = this.element.querySelector('.shopify-payment-button'),
        newButton = document.createElement('button');

      if(addToCartButton){
        newButton.setAttribute('type', 'submit');
        newButton.className = 'ProductForm__AddToCart Button Button--full';

        if (!newVariant) {
          newButton.setAttribute('disabled', 'disabled');
          newButton.removeAttribute('data-action');
          newButton.classList.add('Button--outline');
          newButton.innerHTML = window.languages.productFormUnavailable;
        } else {
          if (newVariant['available']) {
            newButton.removeAttribute('disabled');
            newButton.classList.add('Button--primary');
            newButton.setAttribute('data-action', 'add-to-cart');

            newButton.innerHTML = '<span>' + window.languages.productFormAddToCart + '</span>';

          } else {
            newButton.setAttribute('disabled', 'disabled');
            newButton.classList.add('Button--outline');
            newButton.removeAttribute('data-action');
            newButton.innerHTML = window.languages.productFormSoldOut;
          }
        }

        if (this.options['showPaymentButton'] && shopifyPaymentButton) {
          if (!newVariant || !newVariant['available']) {
            shopifyPaymentButton.style.display = 'none';
          } else {
            shopifyPaymentButton.style.display = 'block';
          }
        }

        // We replace the HTML instead of editing as it prevents for the CSS transition to show up
        addToCartButton.parentNode.replaceChild(newButton, addToCartButton);
      }
    }

    _onChangeCustomPropertyRadio(event, target){
      let selectedValue = target.closest('.ProductForm__CustomProperty').querySelector('.ProductForm__SelectedValue');

      let invalidFeedbackElment = target.closest('.ProductForm__CustomProperty').querySelector('.InvalidFeedback');

      if (selectedValue) {
        selectedValue.innerHTML = target.value;
      }

      if (invalidFeedbackElment) {
        invalidFeedbackElment.classList.add("Valided");
      }
    }

    _onChangeCustomPropertySelect(event, target){
      let invalidFeedbackElment = target.closest('.ProductForm__CustomProperty').querySelector('.InvalidFeedback');
      if (invalidFeedbackElment) {
        if(target.value != ""){
          invalidFeedbackElment.classList.add("Valided");
        }else{
          invalidFeedbackElment.classList.remove("Valided");
        }
      }
    }

    _onChangeCustomPropertyText(event, target){
      let invalidFeedbackElment = target.closest('.ProductForm__CustomProperty').querySelector('.InvalidFeedback');

      if (invalidFeedbackElment) {
        if(target.value != ""){
          invalidFeedbackElment.classList.add("Valided");
        }else{
          invalidFeedbackElment.classList.remove("Valided");
        }
      }
    }

    _onOptionChanged(event, target) {
      //block
      if(target.getAttribute('data-option-position')){
        this['option' + target.getAttribute('data-option-position')] = target.value;
      }else{//select
        let selectedOption = target.options[target.selectedIndex];
        this['option' + selectedOption.getAttribute('data-option-position')] = target.value;
      }
      //label //closest
      let selectedValue = target.closest('.ProductForm__Option').querySelector('.ProductForm__SelectedValue');

      if (selectedValue) {
        selectedValue.innerHTML = target.value;
      }

      // Finally, we get the new variant
      let previousVariant = this.currentVariant;
      this.currentVariant = this._getCurrentVariantFromOptions();

      this._onVariantChanged(previousVariant, this.currentVariant);

      if (this.currentVariant) {
        if (this.options['enableHistoryState']) {
          this._updateHistoryState(this.currentVariant);
        }

        // We need to modify the hidden select that contain the id attribute as well
        this._syncVariantSelector(this.currentVariant);
      }
    }

    _getCurrentVariantFromOptions() {
      let _this = this;
      let found = false;

      this.productData['variants'].forEach(function (variant) {
        if (variant['option1'] === _this.option1 && variant['option2'] === _this.option2 && variant['option3'] === _this.option3) {
          found = variant;
        }
      });

      return found || null;
    }

    _updateHistoryState(variant) {
      if (!history.replaceState) {
        return;
      }

      let newUrl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;

      window.history.replaceState({ path: newUrl }, '', newUrl);
    }

    _addToCart(event) {
      let _this = this;

      // event ist null, wenn der Drawer-Button den Kauf ausloest (addToCart()).
      if (event && event.preventDefault) {
        event.preventDefault(); // Prevent form to be submitted
      }

      let formElement = this.element.querySelector('form.ProductForm');

      if (!formElement.checkValidity()) {
        if(!this.element.classList.contains(".ProductFormValidated")){
          this.element.classList.add('ProductFormValidated');
        }
        return;
      }else{
        this.element.classList.remove('ProductFormValidated')
      }

      let addToCartButton = this.element.querySelector('.ProductForm__AddToCart');

      // First, we switch the status of the button
      if (addToCartButton) addToCartButton.setAttribute('disabled', 'disabled');
      document.dispatchEvent(new CustomEvent('theme:loading:start'));

      // // Then we add the product in Ajax
      // let formElement = this.element.querySelector('form.ProductForm');

      fetch(window.routes.cartAddUrl + '.js', {
        body: JSON.stringify(themegoal.components.Form.serialize(formElement)),
        credentials: 'same-origin',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
        }
      }).then(function (response) {
        document.dispatchEvent(new CustomEvent('theme:loading:end'));

        if (response.ok) {
          if (!_this.options['useAjaxCart']) {
            window.location.href = window.routes.cartUrl;
            // return; // When using a cart type of page, we just simply redirect to the cart page
          }else{
            if (addToCartButton) addToCartButton.removeAttribute('disabled');
            // We simply trigger an event so the mini-cart can re-render
            _this.element.dispatchEvent(new CustomEvent('product:added', {
              bubbles: true,
              detail: {
                variant: _this.currentVariant,
                quantity: parseInt(_this.element.querySelector('[name="quantity"]').value)
              }
            }));
          }
        } else {
          response.json().then(function (content) {
            var errorMessageElement = document.createElement('div');
            errorMessageElement.className = 'Alert Alert--danger';
            if (typeof content['description'] === 'object') {
              errorMessageElement.innerHTML = content['message'];
            }else{
              errorMessageElement.innerHTML = content['description'];
            }
            if (addToCartButton) addToCartButton.removeAttribute('disabled');
            if (addToCartButton) addToCartButton.insertAdjacentElement('beforeBegin', errorMessageElement);
            setTimeout(function () {
              errorMessageElement.remove();
            }, 8000);
          });
        }
      });

      if (event && event.preventDefault) {
        event.preventDefault();
      }
    }

    _decreaseQuantity(event, target) {
      let qty = Math.max(parseInt(this.element.querySelector(".ProductForm__QuantityNum").value) - 1, 1);
      this.element.querySelector(".ProductForm__QuantityNum").value = qty;
      this.element.querySelector('[name="quantity"]').value = qty;
    }

    _increaseQuantity(event, target) {
      let qty = parseInt(this.element.querySelector(".ProductForm__QuantityNum").value) + 1;
      this.element.querySelector(".ProductForm__QuantityNum").value = qty;
      this.element.querySelector('[name="quantity"]').value = qty;
    }


    _validateQuantity(event, target) {
      target.value = Math.max(parseInt(target.value) || 1, 1);
    }

  }

  const components_business = {
      ProductImageModal,
      ProductVariants
  };

  return components_business;

}));
